export default __webpack_public_path__ + "static/icon-7-2-1cfbd3abc33689f34274230b9690c4bb.png";